import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DocumentsApiTest from "./DocumentsApiTest";
import FinanceApiTest from "./FinanceApiTest";
import AdditionalModulesTest from "./AdditionalModulesTest";
import AuthApiTest from "./AuthApiTest";
import UsersApiTest from "./UsersApiTest";
import EventsApiTest from "./EventsAPITest";
import NotificationsApiTest from "./NotificationsAPITest";
import E2EIntegrationTest from "./E2EIntegrationTest";
import PerformanceTest from "./PerformanceTest";
import SecurityTest from "./SecurityTest";
import { BackendIntegrationTest } from "./BackendIntegrationTest";
import { TranslationTest } from "./TranslationTest";
import { TranslationDebugger } from "./TranslationDebugger";
import { LanguageSwitcher } from "../LanguageSwitcher";

const DevDashboardTests: React.FC = () => {
  const { i18n } = useTranslation("dashboard");

  return (
    <>
      {/* Тестирование Documents API */}
      <DocumentsApiTest />

      {/* Тестирование Finance API */}
      <FinanceApiTest />

      {/* Тестирование дополнительных модулей */}
      <AdditionalModulesTest />

      {/* Тестирование Auth API */}
      <AuthApiTest />

      {/* Тестирование Users API */}
      <UsersApiTest />

      {/* Тестирование Events API */}
      <EventsApiTest />

      {/* Тестирование Notifications API */}
      <NotificationsApiTest />

      {/* E2E Тестирование интеграции с Backend API */}
      <E2EIntegrationTest />

      {/* Тестирование производительности */}
      <PerformanceTest />

      {/* Тестирование безопасности */}
      <SecurityTest />

      {/* Базовый тест интеграции с Backend API */}
      <BackendIntegrationTest />

      {/* Тестовый компонент для проверки переводов */}
      <TranslationTest />

      {/* Отладчик переводов */}
      <TranslationDebugger />

      {/* Секция тестирования переводов со ссылкой на тестовую страницу */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          🧪 Тестирование переводов
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Текущий язык: {i18n.language === "ru" ? "Русский" : "English"}
          </Typography>
          <LanguageSwitcher />
        </Box>
        <Button
          variant="outlined"
          component={Link}
          to="/test-translations"
          sx={{ mr: 2 }}
        >
          Открыть тестовую страницу переводов
        </Button>
      </Box>
    </>
  );
};

export default DevDashboardTests;

